import { useAppState } from '../../state';

export default function useConnectionOptions() {
  useAppState();
  return {};
}
